import Divider from 'antd/lib/divider';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import { dayjs } from '@/extendedDayjs';
import * as React from 'react';
import { DatetimeFormat } from '../../timeHelpers';
import { AppStoreAvailableBuild } from '../../types';
import { antGrey } from '../styles/globalStyles';
import { CalendarOutlined } from '@ant-design/icons';
import { BuildSelectorComponent } from '../sharedComponents/buildSelector/BuildSelectorComponent';
import { Nullable } from '@/typescriptHelpers';

export interface MonitoringGeneralReleaseInfoProps {
    releaseId: string;
    releasedAt?: string;
    setSelectedBuild: (build: AppStoreAvailableBuild) => void;
    selectedBuild?: AppStoreAvailableBuild;
    appStoreSelectedBuilds: Nullable<AppStoreAvailableBuild[]>;
}

export const MonitoringGeneralReleaseInfo: React.FC<MonitoringGeneralReleaseInfoProps> = ({
    releasedAt,
    selectedBuild,
    setSelectedBuild,
    appStoreSelectedBuilds,
}) => {
    const handleBuildSelect = (value) => {
        const matchedBuild = appStoreSelectedBuilds.find((build) => build.appStoreBuild.id === value);
        setSelectedBuild(matchedBuild);
    };

    const releasedAtDate = releasedAt ? dayjs(releasedAt).format(DatetimeFormat.ShortMonthDateYear) : '--';

    // Will always be production for now, not sure it adds anything to always show
    // const environment = selectedBuild?.stabilityInfo?.environmentName ?? '--';

    return (
        <div
            className="build-select-component"
            style={{
                maxWidth: 'fit-content',
                height: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
            }}
        >
            {/* <Space>
                <GlobalOutlined width={16} height={16} style={{ color: antGrey.grey6 }} />
                <Typography.Text style={{ color: antGrey.grey8, fontWeight: 600 }}>
                    {capitalize(environment)}
                </Typography.Text>
            </Space> */}
            {/* <Divider type="vertical" /> */}
            <Space>
                <CalendarOutlined width={16} height={16} style={{ color: antGrey.grey6 }} />
                <Typography.Text ellipsis style={{ color: antGrey.grey8, fontWeight: 600 }}>
                    {releasedAtDate}
                </Typography.Text>
            </Space>
            <Divider type="vertical" />
            {selectedBuild && (
                <BuildSelectorComponent
                    appStoreSelectedBuilds={appStoreSelectedBuilds}
                    selectedBuild={selectedBuild}
                    handleBuildSelect={handleBuildSelect}
                />
            )}
        </div>
    );
};
